import { Center, Group, Table, Text, UnstyledButton } from '@mantine/core';
import { FC, memo } from 'react';
import { Icon, type IconType } from 'src/components/Icon';

import styles from './styles.module.css';

type ThProps = {
  children: React.ReactNode;
  reversed: boolean;
  sorted: boolean;
  onSort(): void;
};

export const Th: FC<ThProps> = memo(
  ({ children, reversed, sorted, onSort }) => {
    const iconName: IconType = sorted
      ? reversed
        ? 'arrowSortUp'
        : 'arrowSortDown'
      : 'arrowsSort';

    return (
      <Table.Th className={styles.th}>
        <UnstyledButton onClick={onSort} className={styles.button}>
          <Group>
            <Text>{children}</Text>
            <Center>
              <Icon name={iconName} className={styles.icon} />
            </Center>
          </Group>
        </UnstyledButton>
      </Table.Th>
    );
  }
);
